import { onQuality } from '../platform/quality';
import { vfxReady } from './vfx-pool';
/* ============================================================
   每幀配額 + 延遲排程
   ============================================================

   兩件本來寫在 `weapon-fx.ts` 裡的事，搬出來讓風格模組也能用
   （留在那裡的話 `weapon-fx → styles → weapon-fx` 會形成循環 import）。

   ## 配額

   300 隻同屏時「每次命中都生三層特效」會瞬間吃光池子。所以每一幀有一個
   總配額，超過就**整個事件跳過**（不是畫一半）—— 少一個爆點沒人看得出來，
   畫一半的爆點很明顯。

   ## 延遲排程

   賽璐珞方向要的是**逐格播放**：0.00 秒畫第一張、0.05 秒換第二張、
   0.10 秒換第三張。粒子池沒有 keyframe，`setTimeout` 又會脫離
   `STATE.timeScale`（頓幀的時候特效必須跟著慢下來，否則那 0.06 秒的
   停頓看起來像掉幀而不是打擊）。所以自己排一條吃 dt 的極簡佇列。 */

var used = 0, BUDGET = 26;
onQuality(function (q) {
  BUDGET = q.level === 'low' ? 8 : (q.level === 'medium' ? 18 : 26);
});

/** 借 n 個粒子額度。回 false 表示這一幀已經滿了，呼叫端應該整個事件放棄。 */
export function take(n: number) {
  if (!vfxReady()) return false;
  if (used + n > BUDGET) return false;
  used += n; return true;
}

/** preview 頁專用：同時展示四個版本時，一幀要生四倍的量。
    遊戲裡不要動它 —— 那個數字是量過的（`tools/vfx-perf.mjs`）。 */
export function setBudget(n: number) { BUDGET = n; }

var Q: { t: number; fn: () => void }[] = [];

/** `t` 秒後執行一次。吃 `dt`，所以頓幀與慢動作都會一起慢下來。 */
export function defer(t: number, fn: () => void) { Q.push({ t: t, fn: fn }); }

/** 每畫面幀由 `updateWeaponFx` 呼叫：重置配額並推進延遲佇列。 */
export function beginFrame(dt: number) {
  used = 0;
  if (!Q.length) return;
  for (var i = Q.length - 1; i >= 0; i--) {
    Q[i].t -= dt;
    if (Q[i].t > 0) continue;
    var fn = Q[i].fn;
    Q.splice(i, 1);
    /* **先移除再執行。** 回呼裡再 `defer` 一次（逐格特效的第二、三張就是
       這樣接的）會 push 進同一個陣列，而我們正在反向走它 ——
       先 splice 掉自己，新加的項目落在尾端、下一幀才處理，索引不會錯亂。 */
    fn();
  }
}

/** 場次切換／關掉特效時要清空，否則上一場的延遲影格會在新場開頭噴出來。 */
export function clearDefer() { Q.length = 0; }
